import type { SportId, SportMetric } from '../types'

export const sports: SportId[] = [
  'running',
  'cycling',
  'swimming',
  'crossfit',
  'strength',
]

export const sportMetrics: SportMetric[] = [
  /* Running */
  {
    id: 'running:maxKm',
    sport: 'running',
    label: { 'pt-BR': 'Maior distância', 'en-US': 'Max distance' },
    kind: 'distance',
    value: 18,
    chart: true,
  },
  {
    id: 'running:pace',
    sport: 'running',
    label: { 'pt-BR': 'Pace médio', 'en-US': 'Average pace' },
    kind: 'pace',
    value: 332,
    chart: true,
  },
  {
    id: 'running:longRun',
    sport: 'running',
    label: { 'pt-BR': 'Long run', 'en-US': 'Long run' },
    kind: 'distance',
    value: 16.4,
  },
  {
    id: 'running:split',
    sport: 'running',
    label: { 'pt-BR': 'Split médio', 'en-US': 'Average split' },
    kind: 'pace',
    value: 338,
  },
  {
    id: 'running:pr5k',
    sport: 'running',
    label: { 'pt-BR': 'PR 5 km', 'en-US': '5 km PR' },
    kind: 'duration',
    value: 1540,
  },
  {
    id: 'running:pr10k',
    sport: 'running',
    label: { 'pt-BR': 'PR 10 km', 'en-US': '10 km PR' },
    kind: 'duration',
    value: 2892,
    chart: true,
  },
  {
    id: 'running:pr21k',
    sport: 'running',
    label: { 'pt-BR': 'PR 21 km', 'en-US': '21 km PR' },
    kind: 'duration',
    value: 6750,
  },
  {
    id: 'running:pr42k',
    sport: 'running',
    label: { 'pt-BR': 'PR 42 km', 'en-US': '42 km PR' },
    kind: 'duration',
    value: 0,
  },

  /* Cycling */
  {
    id: 'cycling:ftp',
    sport: 'cycling',
    label: { 'pt-BR': 'FTP', 'en-US': 'FTP' },
    kind: 'power',
    value: 212,
    chart: true,
  },
  {
    id: 'cycling:wkg',
    sport: 'cycling',
    label: { 'pt-BR': 'W/kg', 'en-US': 'W/kg' },
    kind: 'ratio',
    value: 3.4,
    chart: true,
  },

  /* Swimming */
  {
    id: 'swimming:pace',
    sport: 'swimming',
    label: { 'pt-BR': 'Pace de natação', 'en-US': 'Swim pace' },
    kind: 'swimPace',
    value: 118,
    chart: true,
  },
  {
    id: 'swimming:splits',
    sport: 'swimming',
    label: { 'pt-BR': 'Split médio', 'en-US': 'Average split' },
    kind: 'swimPace',
    value: 121,
  },
  {
    id: 'swimming:strokeRate',
    sport: 'swimming',
    label: { 'pt-BR': 'Stroke rate', 'en-US': 'Stroke rate' },
    kind: 'plain',
    value: 34,
  },

  /* CrossFit */
  {
    id: 'crossfit:vo2',
    sport: 'crossfit',
    label: { 'pt-BR': 'VO2 máx', 'en-US': 'VO2 max' },
    kind: 'plain',
    value: 42,
    chart: true,
  },
  {
    id: 'crossfit:1rm',
    sport: 'crossfit',
    label: { 'pt-BR': 'Clean 1RM', 'en-US': 'Clean 1RM' },
    kind: 'weight',
    value: 52,
    chart: true,
  },

  /* Strength training */
  {
    id: 'strength:frequency',
    sport: 'strength',
    label: { 'pt-BR': 'Frequência semanal', 'en-US': 'Weekly frequency' },
    kind: 'plain',
    value: 4,
    chart: true,
  },
  {
    id: 'strength:volume',
    sport: 'strength',
    label: { 'pt-BR': 'Volume semanal', 'en-US': 'Weekly volume' },
    kind: 'weight',
    value: 12400,
    chart: true,
  },
  {
    id: 'strength:squat',
    sport: 'strength',
    label: { 'pt-BR': 'Agachamento 1RM', 'en-US': 'Squat 1RM' },
    kind: 'weight',
    value: 95,
    chart: true,
  },
  {
    id: 'strength:bench',
    sport: 'strength',
    label: { 'pt-BR': 'Supino 1RM', 'en-US': 'Bench 1RM' },
    kind: 'weight',
    value: 52,
  },
  {
    id: 'strength:deadlift',
    sport: 'strength',
    label: { 'pt-BR': 'Terra 1RM', 'en-US': 'Deadlift 1RM' },
    kind: 'weight',
    value: 120,
    chart: true,
  },
]

export function metricsForSport(sport: SportId): SportMetric[] {
  return sportMetrics.filter((metric) => metric.sport === sport)
}

export function findSportMetric(id: string): SportMetric | undefined {
  return sportMetrics.find((metric) => metric.id === id)
}
